import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes, faQrcode } from '@fortawesome/free-solid-svg-icons';


const EventAttendanceAction = ({ scanSource, scannedByUserId, scannedByUserName, scannedUserName, scannedUserCode, event, eventId, eventTitle }) => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [attendanceData, setAttendanceData] = useState([]);
  const [attendanceSaved, setAttendanceSaved] = useState([]);

  const buttonStyle = {
    padding: '10px 20px',
    margin: '10px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  };

  const handleSaveAttendance = async (scanSource, scannedByUserId, scannedByUserName, date, scannedUserName, scannedUserCode, eventId, eventTitle) => {
    
    const newAttendance = {
      eventId,
      eventTitle,
      scannedByUserId,
      scannedByUserName,
      scannedDate: new Date(),  
      scannedUserName,
      scannedUserCode,
      scanSource,
      isActive: true,
      isDeleted: false
    };

    const config = {
        url: '/eventattendance/attendance',
        method: 'post',
        data: { newAttendance },
        headers: { Authorization: authState.token },
      };
      // console.log('Inside Attendance saved:', config);

  
      try {
        await fetchData(config);
        setAttendanceSaved(true);
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    };

    const fieldError = (field) => (
        <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? 'block' : 'hidden'}`}>
          <i className='mr-2 fa-solid fa-circle-exclamation'></i>
          {formErrors[field]}
        </p>
      );


  

  const handleCancelClick = () => {
    // console.log("Cancel clicked");
  };

  const handleScanNextClick = (contactNumber) => {
    // console.log("Scanning next for contact:", contactNumber);
  };

  return (
    <div>
      <div className="flex flex-col text-xl text-blue-700 justify-center items-center mb-4">
        Dear {scannedUserName || 'Guest'}, 
        <span className="text-purple-700">{scannedUserCode}</span> 
        mark your gracious presence compulsorily at the Entry Gate.
      </div>

      <div className="flex flex-row">
        <button 
            onClick={() => handleSaveAttendance(scanSource, scannedByUserId, scannedByUserName, new Date(), scannedUserName, scannedUserCode, eventId, eventTitle)} style={buttonStyle}>
          <FontAwesomeIcon icon={faSave} className="mr-2" /> Save
        </button>
        <button onClick={handleCancelClick} style={buttonStyle}>
          <FontAwesomeIcon icon={faTimes} className="mr-2" /> Cancel
        </button>
        <button onClick={() => handleScanNextClick(event?.contactNumber)} style={buttonStyle}>
          <FontAwesomeIcon icon={faQrcode} className="mr-2" /> Scan Next
        </button>
      </div>
    </div>
  );
};

export default EventAttendanceAction;
